import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { Button } from "../../Components/UI/button";
import { Input } from "../../Components/UI/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow, } from "../../Components/UI/table";
import { TooltipProvider, Tooltip, TooltipContent, TooltipTrigger } from "../../Components/UI/tooltip";
import { Search, Filter, ArrowUp, ArrowDown, CalendarIcon, ArrowDownWideNarrow, UserCircle, Download, Pencil, Building2, Paperclip, ArrowLeft } from "lucide-react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardContent } from "../../Components/UI/card";
import { getTransactionTypesArr } from "../../Store/Reducers";
import PaginationComp from "../../Components/Common/Pagination";
import {
    currentUserHasPermission, FormatAmount, getCurrencySymbol, getDateRangeOptions, getOtherMonthOptions, getOtherQuarterOptions,
    getOtherYearOptions, getPastMonthOptions, getPastQuarterOptions, getRelativeDateText, isRecordInDateRange, truncateText
    , getAllTidMonthData, getMonthsFromMonthlyXns,
    getQuartersFromTransactions,
    getYearsFromTransactions,
    formatAmount
} from "../../Utils/Utilities";
import ContactActions from "../../Components/Common/ContactActions";
import { CommonFilter } from "../../Components/Common/CommonFilter";
import { cn } from "../../Lib/Cn";
import { format } from 'date-fns';
import { Drawer, DrawerClose, DrawerContent, DrawerFooter } from "../../Components/UI/drawer";
import DrawerFilter from "../../Components/Common/DrawerFilter";
import { RiResetLeftFill } from "react-icons/ri";
import useIsMobile from "../../Hooks/useIsMobile";
import { useVirtualizer } from "@tanstack/react-virtual";
import ThreadSahiIcon from "../../Components/Common/ThreadSahiIcon";
import { Checkbox } from "../../Components/UI/checkbox";
import { setGlobalLoading } from "../../Store/Actions";
import { toast } from "sonner";
import { getTransactionAPI } from "../Connections/TransactionAPI";
import TransactionDropdown from "../Connections/TransactionDropdown";
import { exportToExcel } from "../../Utils/ExcelExportUtils";
import TransactionEntry from "../Connections/Tabs/TransactionEntry";
import { flushSync } from "react-dom";
import { useCurrency } from "../../Hooks/useCurrency";
import ImportXnsExcel from "../Connections/ImportXnsExcel";
import { DatePicker } from "../../Components/Common/DatePicker";
import { FaFileExcel } from "react-icons/fa6";
import { SHOW_IMPORT_INQUIRIES, canShowImportInquiries } from "../../Utils/FeatureFlags";

const sortKeyMap = {
    bizName: "bizName",
    amtGrandTotal: "amtGrandTotal",
    xnDT: "xnDT",
    xnNo: "xnNo",
    contact: "contactName"
};

const sortkeyMapMobileFilter = {
    "Amount (highest first)": { key: "amtGrandTotal", direction: "desc" },
    "Amount (lowest first)": { key: "amtGrandTotal", direction: "asc" },
    "Date (newest first)": { key: "xnDT", direction: "desc" },
    "Date (oldest first)": { key: "xnDT", direction: "asc" },
    "Business name (A-Z)": { key: "bizName", direction: "asc" },
    "Contact (A-Z)": { key: "contact", direction: "asc" },
}

let checkBoxCss = "data-[state=checked]:bg-sahi-primary-color data-[state=checked]:border-sahi-primary-color data-[state=checked]:text-white  transition-colors"
var filterBtn = "button-config sahi-primary-button flex items-center justify-center group px-2.5 py-[5px]";
let actionButton = "action-btn-effect hover:bg-sahi-blue-light";

const Transactions = () => {
    const location = useLocation();
    const isMobile = useIsMobile();
    const clickedTabRef = useRef(null);
    const parentRef = useRef(null);
    const dispatch = useDispatch()
    const currencySymbol = useCurrency();
    //Query Params
    const searchParams = new URLSearchParams(location.search);
    const txnTypeParam = parseInt(searchParams.get("xid"), 10);
    const [paramConnID, setParamConnID] = useState('')

    const { data: connectionData } = useSelector((state) => state.connectionData);
    const [isLoading, setIsLoading] = useState(true);
    const txnTypes = useSelector(getTransactionTypesArr);

    const [txn, setTxns] = useState([]);
    const [filteredTxns, setFilteredTxns] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [openXnsImpModal, setXnsImpModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [activeTab, setActiveTab] = useState("sort");
    const [preSearchTxns, setPreSearchTxns] = useState([]); // filtered by filters only
    const [selectedTransaction, setSelectedTransaction] = useState(null);
    const prevFiltersRef = useRef({});
    const [hideTypeColumn, setHideTypeColumn] = useState(false);
    const [connData, setConndata] = useState([])

    const [selectedTransactionType, setSelectedTransactionType] = useState(1);
    const xnActions = currentUserHasPermission('XnActions');
    const canEditXn = xnActions === 1 || xnActions === 2;
    const canCreateXn = xnActions === 1 || xnActions === 3;

    // useful for sorting and filter
    const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
    const [isFilterSelected, setIsFilterSelected] = useState(false);
    const [selectedFilters, setSelectedFilters] = useState({
        txnTypes: txnTypeParam && Number(txnTypeParam) !== 0 ? String(txnTypeParam) : "123456",
        connID: "all",
        dateRange: "This Month",
        otherMonth: "all",
        otherQuarter: "all",  // Add this
        otherYear: "all",
        selectDate: false,
        selectedDate: null
    });
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [tempFilters, setTempFilters] = useState(selectedFilters);
    const [tempsortConfig, setTempsortConfig] = useState(sortConfig);
    const [transactionDropdownOpen, setTransactionDropdownOpen] = useState(false);
    const [transactionDropdownOpen2, setTransactionDropdownOpen2] = useState(false);
    const [transactionPrefilledData, setTransactionPrefilledData] = useState({});
    const [dialogStates, setDialogStates] = useState({
        transactionEntry: false,
    })
    let showPreTaxColumn = false;
    const preTaxHeaderIDs = [1, 2, 3, 4];

    //Transactions table header Obj
    const transactionTableHeadersData = [
        { key: "xnTypeID", label: "", className: "align-middle text-text-color w-[3vw]" },
        { key: "bizName", label: "Business", className: "lg:w-[200px] xl:w-[240px] 2xl:w-[300px] align-middle" },
        { key: "contact", label: "Contact", className: "align-middle" },
        { key: "xnNo", label: "Ref No.", className: "align-middle text-text-color whitespace-nowrap" },
        {
            key: "amtSubTotal",
            label: <div className="flex justify-end w-full whitespace-nowrap">
                Pre-Tax (<span>{currencySymbol}</span>)
            </div>,
            className: "align-middle text-right"
        },
        {
            key: "amtGrandTotal",
            label: <div className="flex justify-end w-full whitespace-nowrap">
                Amount (<span>{currencySymbol}</span>)
            </div>,
            className: "align-middle text-right"
        },
        { key: "xnDT", label: "Date", className: "align-middle" },
        { key: "intNotes", label: "Notes", className: "align-middle w-[22vw]" },
    ];

    const calculateTransactionTypeStats = (transactions, selectedFilters, isRecordInDateRange) => {
        const { connID, dateRange, finYear, otherMonth, otherQuarter, otherYear } = selectedFilters;

        const filteredForStats = transactions.filter(xn => {
            if (connID && connID !== "all") {
                if (xn.connID.toString() !== connID.toString()) return false;
            }

            if (!isRecordInDateRange(xn.xnDT, dateRange, finYear, otherMonth, otherQuarter, otherYear)) {
                return false;
            }

            return true;
        });

        const typeStats = {};
        filteredForStats.forEach(xn => {
            const typeId = xn.xnTypeID.toString();
            if (!typeStats[typeId]) {
                typeStats[typeId] = { count: 0, totalAmount: 0 };
            }
            typeStats[typeId].count++;
            typeStats[typeId].totalAmount += Number(xn.amtGrandTotal) || 0;
        });

        return typeStats;
    };

    const getTransactionTypeOptions = () => {
        const typeStats = calculateTransactionTypeStats(txn, selectedFilters, isRecordInDateRange);

        return txnTypes.map(type => {
            const stats = typeStats[type.XnTID.toString()];
            const count = stats?.count || 0;
            const totalAmount = stats?.totalAmount.toLocaleString("en-US") || 0;

            const displayLabel = type.LblF === "Sales Invoice" ? "Sales" :
                type.LblF === "Purchase Invoice" ? "Purchases" :
                    `${type.LblF || type.Label}s`;

            return {
                name: `${displayLabel} (${currencySymbol} ${totalAmount})`,
                ID: type.XnTID.toString(),
                disabled: count === 0,
                count: count,
                totalAmount: totalAmount,
                icon: type.XnTID,
                group: type.Typ === "S" ? "sales" : type.Typ === "P" ? "purchases" : "other"
            };
        }).filter(option => option.count > 0); // Only show types with transactions
    };

    const filterOptions = [
        {
            key: "dateRange",
            label: "All Time",
            options: getDateRangeOptions(),
            searchEnabled: false,
            type: "options",
            showClearButton: false,
            MobileLabel: "Time",
            showAllOption: true,
        },
        {
            key: "otherMonth",
            label: "Select Month",
            options: getMonthsFromMonthlyXns(),
            disabled: !(selectedFilters.dateRange === "Other Month" || tempFilters.dateRange === "Other Month"),
            mobiledisabled: !(tempFilters.dateRange === "Other Month"),
            type: "list",
            mobileDropdownText: "Select Month",
            mobileNoLabel: true,
            isSorting: false
        },
        {
            key: "selectDate",
            label: "Select Date",
            type: "selectDate",
            visibleWhen: (selectedFilters.dateRange === "This Month" || tempFilters.dateRange === "This Month") || 
                         (selectedFilters.dateRange === "Other Month" && selectedFilters.otherMonth !== "all") ||
                         (tempFilters.dateRange === "Other Month" && tempFilters.otherMonth !== "all"),
            MobileLabel: "Select Date",
        },
        {
            key: "otherQuarter",
            label: "Select Quarter",
            options: getQuartersFromTransactions(txn),
            disabled: !(selectedFilters.dateRange === "Other Quarter" || tempFilters.dateRange === "Other Quarter"),
            mobiledisabled: !(tempFilters.dateRange === "Other Quarter"),
            type: "list",
            mobileDropdownText: "Select Quarter",
            mobileNoLabel: true,
            isSorting: false
        },
        {
            key: "otherYear",
            label: "Select Year",
            options: getYearsFromTransactions(txn),
            disabled: !(selectedFilters.dateRange === "Other Year" || tempFilters.dateRange === "Other Year"),
            mobiledisabled: !(tempFilters.dateRange === "Other Year"),
            type: "list",
            mobileDropdownText: "Select Year",
            mobileNoLabel: true,
            isSorting: false
        },
        {
            key: "connID",
            label: "All Contacts",
            options: connData.map((c) => ({ name: c.bizName, ID: c.connID })),
            displayValue: (val) => {
                const numVal = Number(val);
                return connData.find((c) => Number(c.connID) === numVal)?.bizName || "";
            },
            type: "list",
            mobileDropdownText: "Select Contact",
            MobileLabel: "Contacts",
            showAllOption: true
        },
        {
            key: "txnTypes",
            label: "Transaction Types",
            options: getTransactionTypeOptions().map((t) => ({ name: t.name, ID: t.ID })), // You'll need to implement this function
            searchEnabled: false,
            type: "options", // or "checkbox" depending on your component structure
            showClearButton: true,
            MobileLabel: "Types",
            showAllOption: true,
            mobileDropdownText: "Select Type",
            isSorting: false,
        }
    ]

    useEffect(() => {
        if (!isMobile)
            setIsFilterSelected(true)
    }, [])

    // mobile filters icon click button
    const handleFilterIconClick = (key) => {
        setActiveTab(key);
        clickedTabRef.current = true;
        setTimeout(() => {
            clickedTabRef.current = false;
        }, 500);
        const el = document.getElementById(key);
        if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    // Filter headers based on hideTypeColumn state
    const getFilteredHeaders = () => {
        showPreTaxColumn = currentXns.some((xn) => preTaxHeaderIDs.includes(xn.xnTypeID))
        return transactionTableHeadersData.filter(header => {
            if (hideTypeColumn && header.key === 'xnTypeID') {
                return false;
            }
            if (header.key === 'amtSubTotal') return showPreTaxColumn;
            return true;
        });
    };

    useEffect(() => {
        if (isFilterSelected || isMobile) {
            setIsDrawerOpen(true);
            // setTempsortConfig(sortConfig);
            setTempFilters(selectedFilters);
        }
    }, [isFilterSelected, isMobile]);

    //connection data for filter
    useEffect(() => {
        if (!Array.isArray(connectionData)) {
            setConndata([]);
            return;
        }
        const processed = connectionData
            .filter(item => !(item.IsCold === 1 || item.IsCold === true))
            .map(item => ({
                connID: item.ConnID,
                bizName: item.BizName || "", // Provide fallback empty string
            }))
            .sort((a, b) => {
                // Safe comparison with fallback
                const nameA = a.bizName || "";
                const nameB = b.bizName || "";
                return nameA.localeCompare(nameB);
            });
        setConndata(processed);
    }, [connectionData]);

    const fetchTransactionData = async () => {
        dispatch(setGlobalLoading(true));
        try {
            const params = {
                xnTypeID: "0",
                prdType: "ALL",
                prdQty: "1",
                year: "0",
                month: "0",
            };
            const result = await getTransactionAPI(params);
            const processedXns = getTxnObj(result);
            // Check if we have any transactions for the current month
            const now = new Date();
            const currentMonth = now.getMonth(); // 0-11
            const currentYear = now.getFullYear();

            const thisMonthTxns = processedXns.filter(xn => {
                if (!xn.xnDT) return false;
                const date = new Date(xn.xnDT);
                return (
                    date.getMonth() === currentMonth &&
                    date.getFullYear() === currentYear
                );
            });

            if (!thisMonthTxns.length) {
                // No txns in current month → fallback to all time
                setSelectedFilters(prev => ({
                    ...prev,
                    dateRange: "All Time",
                }));
            }
            setTxns(processedXns);
        } catch (error) {
            toast.error("Error fetching transactions:", error)
            setTxns([]);
        } finally {
            dispatch(setGlobalLoading(false));
        }
    };

    //API for Txns data
    useEffect(() => {
        fetchTransactionData();
    }, []);

    //Object making
    const getTxnObj = (txn) => {
        return txn.map((x) => {
            const conn = connectionData.find((c) => c.ConnID === x.ConnID) || {};

            return {
                xnID: x.XnID,
                xnNo: x.XnNo,
                xnDT: x.XnDate,
                xnTypeID: x.XnTypeID,
                xnFile: x.XnFile,
                connID: x.ConnID,
                intNotes: x.IntNotes,
                amtSubTotal: x.AmtSubTotal,
                amtTaxTotal: x.AmtTaxTotal,
                amtGrandTotal: x.AmtGrandTotal,
                currencyID: x.CurrencyID,
                dueDT: x.DueDate,
                isSeller: x.IsSeller,

                buyerAgencyName: x.BuyerAgencyName || "",
                buyerUserName: x.BuyerUserName || "",
                buyerMobile: x.BuyerMobile || "",
                buyerEmail: x.BuyerEmail || "",
                buyerTaxID: x.BuyerTaxID || "",
                buyerCC: x.BuyerCC || "",

                sellerAgencyName: x.SellerAgencyName || "",
                sellerUserName: x.SellerUserName || "",
                sellerMobile: x.SellerMobile || "",
                sellerEmail: x.SellerEmail || "",
                sellerTaxID: x.SellerTaxID || "",
                sellerCC: x.SellerCC || "",

                // mapped connection data
                bizName: conn.BizName || "",
                mobile: conn.Mobile || "",
                email: conn.Email || "",
                connType: conn.ConnType || "",
                contactName: conn.ContactName || "",
            };
        });
    };

    // Apply filters
    useEffect(() => {
        setIsLoading(true);
        applyFilters();
        setIsLoading(false);
    }, [txn, selectedFilters]);

    //managing paramConnID params
    useEffect(() => {
        const conn = searchParams.get("cid");
        if (conn && conn !== paramConnID) {
            setParamConnID(conn);
        }
    }, [location.search]);

    useEffect(() => {
        if (paramConnID !== '') {
            setSelectedFilters(prev => ({
                ...prev,
                connID: paramConnID,
            }));
            setTempFilters(prev => ({
                ...prev,
                connID: paramConnID,
            }));
            if (!isMobile) {
                setIsFilterSelected(true);
            }
        }
    }, [paramConnID, isMobile]);

    const isTransactionsEmpty = () => !txn || txn.length === 0;

    // Helper functions for conditional UI
    const hasTransactionData = (transactions) => {
        return transactions.length > 0;
    };

    const shouldShowFullUI = (transactions) => {
        return hasTransactionData(transactions);
    };


    //Reset Sort Function
    const resetSort = () => {
        setSortConfig({ key: null, direction: null });
    };

    //For getting Value
    const getNestedValue = (obj, path) => {
        return path.split(".").reduce((o, k) => (o ? o[k] : ""), obj);
    };

    //Sorting function
    const sortData = (key, dir) => {
        if (!key && !dir) return;
        const actualKey = sortKeyMap[key] || key;
        let direction =
            dir ??
            (sortConfig.key === actualKey && sortConfig.direction === "asc" ? "desc" : "asc");
        setSortConfig({ key: actualKey, direction });
        const sorted = [...filteredTxns].sort((a, b) => {
            let lowerVal, upperVal;

            lowerVal = getNestedValue(a, actualKey);
            upperVal = getNestedValue(b, actualKey);

            // Handle numeric fields
            if (["amtGrandTotal"].includes(key)) {
                lowerVal = Number(lowerVal) || 0;
                upperVal = Number(upperVal) || 0;
                return direction === "asc" ? lowerVal - upperVal : upperVal - lowerVal;
            }

            // Handle date fields
            if (["xnDT"].includes(key)) {
                lowerVal = lowerVal ? new Date(lowerVal).getTime() : 0;
                upperVal = upperVal ? new Date(upperVal).getTime() : 0;
                return direction === "asc" ? lowerVal - upperVal : upperVal - lowerVal;
            }

            // Handle string fields

            lowerVal = lowerVal?.toString().toLowerCase() || "";
            upperVal = upperVal?.toString().toLowerCase() || "";

            return direction === "asc"
                ? lowerVal.localeCompare(upperVal)
                : upperVal.localeCompare(lowerVal);
        });
        setFilteredTxns(sorted);
        setPreSearchTxns(sorted);
    };

    //Serch Filter
    useEffect(() => {
        const term = searchTerm.trim().toLowerCase();

        if (!term) {
            setFilteredTxns(preSearchTxns);
            return;
        }

        const filtered = preSearchTxns.filter((txn) => {
            const fieldsToSearch = [
                txn.xnNo,
                txn.xnFile,
                txn.buyerUserName,
                txn.sellerUserName,
                txn.bizName,
                txn.mobile,
                txn.email,
                txn.contactName,
                txn.intNotes,
                txn.amtGrandTotal?.toString(),
            ];

            return fieldsToSearch
                .filter(Boolean)
                .some((field) =>
                    field.toString().toLowerCase().includes(term)
                );
        });

        setFilteredTxns(filtered);
        setCurrentPage(1);
    }, [searchTerm, preSearchTxns]);

    //Apply Filters Function
    //Apply Filters Function
    const applyFilters = () => {
        setIsLoading(true);
        const {
            txnTypes,
            connID,
            dateRange,
            otherMonth,
            otherQuarter,  // Add this
            otherYear,      // Add this
            selectDate,
            selectedDate
        } = selectedFilters;

        const isFilterAdded = (curr, prev) => {
            return (
                (prev === "all" && curr !== "all") || (prev === undefined && curr !== "all")
            );
        };

        const prev = prevFiltersRef.current;
        const isEmptyPrev = !prev || Object.keys(prev).length === 0;

        const isRefined =
            isFilterAdded(connID, prev.connID) ||
            isFilterAdded(dateRange, prev.dateRange) ||
            isFilterAdded(otherMonth, prev.otherMonth) ||
            isFilterAdded(otherQuarter, prev.otherQuarter) ||
            isFilterAdded(otherYear, prev.otherYear) ||
            isFilterAdded(txnTypes, prev.txnTypes) ||
            (prev?.selectDate !== selectDate) ||
            (prev?.selectedDate !== selectedDate);

        const baseList = txn;
        const filtered = [];

        // Get available transaction type IDs from actual data
        const availableTypeIDs = [...new Set(txn.map(x => x.xnTypeID.toString()))];

        for (const xn of baseList) {
            // Transaction Types filter
            if (txnTypes && txnTypes !== "all" && txnTypes !== "123456") {
                // Filter out only the types that exist in actual data
                const selectedTypes = txnTypes.split('').filter(t => t !== '' && availableTypeIDs.includes(t));

                if (selectedTypes.length === 1) {
                    setHideTypeColumn(true);
                } else {
                    setHideTypeColumn(false);
                }

                // If no valid types are selected, skip this transaction
                if (selectedTypes.length === 0 || !selectedTypes.includes(xn.xnTypeID.toString())) {
                    continue;
                }
            } else {
                setHideTypeColumn(false);
            }

            // Connection filter
            if (connID && connID !== "all") {
                if (xn.connID.toString() !== connID.toString()) continue;
            }

            // Date range filter
            if (!isRecordInDateRange(xn.xnDT, dateRange, '', otherMonth, otherQuarter, otherYear)) {
                continue;
            }

            if (selectDate && selectedDate) {
                const xnDateString = xn.xnDT.split('T')[0];
                
                const dateObj = new Date(selectedDate);
                const year = dateObj.getFullYear();
                const month = String(dateObj.getMonth() + 1).padStart(2, '0');
                const day = String(dateObj.getDate()).padStart(2, '0');
                const selectedDateString = `${year}-${month}-${day}`;
                
                if (xnDateString !== selectedDateString) {
                    continue;
                }
            }

            filtered.push(xn);
        }

        setFilteredTxns(filtered);
        setPreSearchTxns(filtered);
        setCurrentPage(1);
        prevFiltersRef.current = { txnTypes, connID, dateRange, otherMonth, otherQuarter, otherYear, selectDate, selectedDate };
        setIsLoading(false);
    };

    //handle actions Function
    const handleItemAction = (action, transaction, type, event) => {
        event?.stopPropagation();
        switch (action) {
            case "EDIT":
                if (type === "transaction") {
                    const invoiceDate = transaction.xnDT ? new Date(transaction.xnDT) : null;
                    const dueDate = transaction.dueDT ? new Date(transaction.dueDT) : null;
                    const prefilledData = {
                        connection: transaction.connID,
                        contactPerson: transaction.isSeller ? transaction.buyerUserName : transaction.sellerUserName,
                        invoiceNo: transaction.xnNo,
                        referenceNo: transaction.connRefNo,
                        xnDate: invoiceDate ? format(invoiceDate, "yyyy-MM-dd") : "",
                        dueDate: dueDate ? format(dueDate, "yyyy-MM-dd") : "",
                        notes: transaction.intNotes,
                        bizName: transaction.isSeller ? transaction.buyerAgencyName : transaction.sellerAgencyName,
                        contactName: transaction.isSeller ? transaction.buyerUserName : transaction.sellerUserName,
                        fileName: transaction.xnFile || "",
                        preTaxAmount: transaction.amtSubTotal,
                        taxAmount: transaction.amtTaxTotal,
                        totalAmount: transaction.amtGrandTotal
                    };
                    // Handle edit logic here
                    setSelectedTransactionType(transaction.xnTypeID);
                    setSelectedTransaction(transaction);
                    setTransactionPrefilledData(prefilledData);
                    setDialogStates((prev) => ({ ...prev, transactionEntry: true }));
                }
                break;
            case "DOWNLOAD":
                if (transaction.xnFile) {
                    const fileUrl = `/Uploads/${transaction.xnFile}`;
                    window.open(fileUrl, "_blank");
                }
                break;
            default:
                break;
        }
    };

    // Helper function to get min and max dates based on selected filters
    const getDatePickerLimits = () => {
        const now = new Date();
        
        // Check if "This Month" is selected
        if (selectedFilters.dateRange === "This Month" || tempFilters.dateRange === "This Month") {
            return {
                minDate: new Date(now.getFullYear(), now.getMonth(), 1),
                maxDate: new Date(now.getFullYear(), now.getMonth() + 1, 0)
            };
        }
        
        // Check if "Other Month" is selected with a specific month
        const otherMonth = selectedFilters.otherMonth || tempFilters.otherMonth;
        if ((selectedFilters.dateRange === "Other Month" || tempFilters.dateRange === "Other Month") && 
            otherMonth && otherMonth !== "all") {
            // Parse "Jan 2025" format
            const [monthName, yearStr] = otherMonth.split(' ');
            const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            const monthIndex = months.indexOf(monthName);
            const year = parseInt(yearStr);
            
            if (monthIndex !== -1) {
                return {
                    minDate: new Date(year, monthIndex, 1),
                    maxDate: new Date(year, monthIndex + 1, 0)
                };
            }
        }
        
        return { minDate: undefined, maxDate: undefined };
    };

    // Pagination
    const totalPages = Math.ceil(filteredTxns.length / rowsPerPage);
    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;

    //Current Xns
    const currentXns = useMemo(() => {
        const sorted = !sortConfig.key
            ? [...filteredTxns].sort((a, b) => {
                const lowerDate = a.xnDT ? new Date(a.xnDT).getTime() : 0;
                const upperDate = b.xnDT ? new Date(b.xnDT).getTime() : 0;
                return upperDate - lowerDate;
            })
            : filteredTxns;

        if (isMobile) return sorted;

        const sliced = sorted.slice(startIndex, endIndex);
        return sliced.length > 0 ? sliced : sorted;
    }, [filteredTxns, sortConfig, currentPage, rowsPerPage, isMobile]);

    // tan stack virtualizer for rendering cards in mobile efficiently
    const rowVirtualizer = useVirtualizer({
        count: currentXns.length,
        getScrollElement: () => parentRef.current,
        estimateSize: () => 140,
        overscan: 5,
    });

    //Drawerfilter Cancel Function
    const handleCancel = () => {
        setTempFilters(selectedFilters);
        setIsFilterSelected(false);
        setIsDrawerOpen(false);
        setTempsortConfig(sortConfig);
    };

    //Reset Filters Button
    const handleResetFilters = () => {
        const cleared = {
            txnTypes: txnTypeParam && Number(txnTypeParam) !== 0 ? String(txnTypeParam) : "123456",
            connID: "all",
            dateRange: "This Month",
            otherMonth: "all",
            otherQuarter: "all",  // Add this
            otherYear: "all"
        };
        resetSort();
        setSelectedFilters(cleared);
        setSearchTerm("");
        setIsDrawerOpen(false);
        setTempFilters(cleared);
        setTempsortConfig({ key: null, direction: null });
        setSearchTerm("");
        setSortConfig({ key: null, direction: null });
    };

    //Mobile card Component
    const MobileCard = ({ txn }) => {
        return (
            <div className="bg-sahi-white sahi-radius shadow-sm border border-gray-200 mb-2 w-full f-col justify-between">
                {/* Header Section */}
                <div className="f-col gap-1 mobile-tile-header-layout">
                    <div className="f-row justify-between gap-2">
                        <div className="f-col items-center justify-between">
                            <div className="f-col min-w-0 gap-1">
                                <div className="flex items-center gap-2 mb-1 ">
                                    <Building2 size={14} />
                                    <span className={`${isMobile ? 'text-xs' : 'text-sm'} font-semibold`}>
                                        {truncateText(txn.bizName, 25)}
                                    </span>
                                </div>
                                <p className=" text-sub-text-color text-sm truncate max-w-full">
                                    {txn.isSeller ? txn.buyerUserName : txn.sellerUserName || "-"}
                                </p>
                                <p className="text-sub-text-color text-xs">
                                    {truncateText(txn.intNotes, 26)}
                                </p>
                            </div>
                        </div>

                        <div className="f-col items-end text-right gap-1">
                            {!hideTypeColumn && (
                                <div className="flex justify-between items-center gap-1 mb-1">
                                    <ThreadSahiIcon
                                        tID={txn.xnTypeID}
                                        className="h-4 w-4 shrink-0"
                                        hoverName
                                        Xns={true}
                                    />
                                    {(() => {
                                        const type = txnTypes.find(
                                            (t) => t.XnTID.toString() === txn.xnTypeID.toString()
                                        );

                                        return (
                                            <span
                                                className={`text-[11px] xs:text-xs font-normal ${type?.Typ === "S" ? "text-sahi-green" : "text-sahi-orange"
                                                    }`}
                                            >
                                                {type?.LblF || "--"}
                                            </span>
                                        );
                                    })()}
                                </div>
                            )}

                            <span className=" text-sm font-medium text-color  align-bottom">
                                <FormatAmount
                                    amtClassName={`text-xs`}
                                    amount={txn.amtGrandTotal}
                                    currency={getCurrencySymbol(txn.currencyID)}
                                />
                            </span>
                            {txn.xnNo && (
                                <p className="text-xs text-sub-text-color truncate mt-1">
                                    #{" "}
                                    <strong>
                                        {txn.xnNo}
                                    </strong>
                                </p>
                            )}
                        </div>
                    </div>
                </div>

                {/* Footer Section */}
                <div className="flex justify-between items-center text-xs border-t border-[#f1f1f1] w-full mobile-tile-footer-layout ">
                    <div>
                        {txn.xnDT && (
                            <span className="text-xs text-sub-text-color truncate f-row gap-0.5  items-center justify-between">
                                <strong>
                                    {getRelativeDateText(txn.xnDT, false, true, false, true) || "-"}
                                </strong>
                            </span>
                        )}
                    </div>
                    <div className="flex items-center justify-end gap-2 xl:gap-2.5 ">
                        {txn.xnFile && (
                            <Tooltip>
                                <TooltipTrigger asChild>
                                    <Button
                                        variant="ghost"
                                        size="sm"
                                        className={`!px-0 !mx-0 ${actionButton}`}
                                        onClick={(e) => handleItemAction("DOWNLOAD", txn, "transaction", e)}
                                    >
                                        <Paperclip className="h-3 w-3 text-sahi-blue" />
                                    </Button>
                                </TooltipTrigger>
                                <TooltipContent>
                                    <p>Attachment</p>
                                </TooltipContent>
                            </Tooltip>
                        )}

                        <ContactActions
                            connectionData={{
                                mobile: txn.isSeller ? txn.buyerMobile : txn.sellerMobile,
                                email: txn.isSeller ? txn.buyerEmail : txn.sellerEmail,
                                cc: txn.isSeller ? txn.buyerCC : txn.sellerCC
                            }}
                            showEmail={false}
                        />

                        {canEditXn && <Tooltip>
                            <TooltipTrigger asChild>
                                <Button
                                    variant="ghost"
                                    size="sm"
                                    className={`!px-0 !mx-0 ${actionButton}`}
                                    onClick={(e) => handleItemAction("EDIT", txn, "transaction", e)}
                                >
                                    <Pencil className="h-3 w-3 text-sahi-blue px-0 mx-0" />
                                </Button>
                            </TooltipTrigger>
                            <TooltipContent>
                                <p>Edit Transaction</p>
                            </TooltipContent>
                        </Tooltip>}
                    </div>
                </div>
            </div>
        );
    }

    // Table For Web view
    const WebDataTable = () => {
        return (
            <>
                {isLoading ? (
                    null) : (
                    currentXns.length === 0 ? (
                        <>
                            <div className="f-col items-start gap-5 mt-0">
                                <div className="no-records border border-gray-200 shadow-sm sahi-radius">
                                    No transactions found.
                                </div>

                                <div className="flex items-center gap-3">
                                    {canCreateXn == true && canShowImportInquiries() &&
                                        <Button
                                            variant="outline"
                                            className="button-config text-base sahi-primary-button py-[6px] px-[10px]"
                                            onClick={() => setXnsImpModal(true)}
                                        >
                                            <div className="flex items-center cursor-pointer">
                                                <Download className="h-4 w-4 mr-2" />
                                                Import
                                            </div>
                                        </Button>}

                                    <TransactionDropdown
                                        onTransactionTypeSelect={handleNewTransaction}
                                        externalOpen={transactionDropdownOpen}
                                        onExternalOpenChange={setTransactionDropdownOpen}
                                        className="text-sm"
                                    />
                                </div>
                            </div>
                        </>
                    ) : (
                        <>
                            <Card className="bg-sahi-white hidden lg:block !pt-0 overflow-hidden ">
                                <CardContent className="px--5 !sahi-radius">
                                    <Table className="min-w-full table-auto">
                                        <TableHeader>
                                            <TableRow className="bg-sahi-white py-1.5 h-11" >
                                                {getFilteredHeaders().map(
                                                    ({ key, label, className = "", style = {} }) => (
                                                        <TableHead
                                                            key={key}
                                                            className={`table-header-text  word-break-px ${className}`}
                                                            style={style}
                                                            onClick={() => sortData(key)}
                                                        >
                                                            <div className="flex items-center cursor-pointer break-words">
                                                                {label}
                                                                {!["xnTypeID"].includes(key) &&
                                                                    sortConfig.key === (sortKeyMap[key] || key) &&
                                                                    sortConfig.direction && (
                                                                        sortConfig.direction === "asc" ? (
                                                                            <ArrowUp className="ml-1 h-4 w-4 text-black" />
                                                                        ) : (
                                                                            <ArrowDown className="ml-1 h-4 w-4 text-black" />
                                                                        )
                                                                    )}
                                                            </div>
                                                        </TableHead>
                                                    )
                                                )}
                                                <TableHead className="table-header-text whitespace-nowrap text-left pr-2 align-top w-32">
                                                </TableHead>
                                            </TableRow>
                                        </TableHeader>
                                        <TableBody>
                                            {currentXns.map((xn) => (
                                                <TableRow
                                                    key={xn.xnID}
                                                    className="hover:bg-gray-50 cursor-pointer"
                                                >
                                                    {!hideTypeColumn && (
                                                        <TableCell className="w-[3vw] px-4 text-center">
                                                            <div className="flex">
                                                                <ThreadSahiIcon tID={xn.xnTypeID} hoverName Xns={true} />
                                                            </div>
                                                        </TableCell>
                                                    )}
                                                    <TableCell className="word-non-break-px pl-2">
                                                        {xn.bizName || "-"}
                                                    </TableCell>
                                                    <TableCell className="word-non-break-px text-nowrap pr-2">
                                                        {xn.isSeller ? xn.buyerUserName : xn.sellerUserName || "-"}
                                                    </TableCell>
                                                    <TableCell className="word-non-break-px text-nowrap pr-2">
                                                        {xn.xnNo || "-"}
                                                    </TableCell>
                                                    {showPreTaxColumn && <TableCell className="word-non-break-px text-right text-nowrap pr-2 !text-sm font-medium">
                                                        {preTaxHeaderIDs.includes(xn.xnTypeID) &&
                                                            <FormatAmount
                                                                amount={xn.amtSubTotal}
                                                                currency={currencySymbol}
                                                                showCurr={false}
                                                            />
                                                        }
                                                    </TableCell>}
                                                    <TableCell className="word-non-break-px text-right text-nowrap pr-2 !text-sm font-medium">
                                                        <FormatAmount
                                                            amount={xn.amtGrandTotal}
                                                            currency={currencySymbol}
                                                            showCurr={false}
                                                        />
                                                    </TableCell>
                                                    <TableCell className="word-break-px">
                                                        <span className="break-words">
                                                            {getRelativeDateText(xn.xnDT, false, true, false, true) || "-"}
                                                        </span>
                                                    </TableCell>
                                                    <TableCell className="word-non-break-px text-nowrap pr-2">
                                                        {xn.intNotes || "-"}
                                                    </TableCell>
                                                    <TableCell className={`text-right`}>
                                                        <div className="flex items-center justify-end gap-2 xl:gap-2.5 pr-2">
                                                            {xn.xnFile && (
                                                                <Tooltip>
                                                                    <TooltipTrigger asChild>
                                                                        <Button
                                                                            variant="ghost"
                                                                            size="sm"
                                                                            className={`!px-0 !mx-0 ${actionButton}`}
                                                                            onClick={(e) => handleItemAction("DOWNLOAD", xn, "transaction", e)}
                                                                        >
                                                                            <Paperclip className="h-3 w-3 text-sahi-blue " />
                                                                        </Button>
                                                                    </TooltipTrigger>
                                                                    <TooltipContent>
                                                                        <p>Attachment</p>
                                                                    </TooltipContent>
                                                                </Tooltip>
                                                            )}

                                                            <ContactActions
                                                                connectionData={{
                                                                    mobile: xn.isSeller ? xn.buyerMobile : xn.sellerMobile,
                                                                    email: xn.isSeller ? xn.buyerEmail : xn.sellerEmail,
                                                                    cc: xn.isSeller ? xn.buyerCC : xn.sellerCC
                                                                }}
                                                                showEmail={false}
                                                            />

                                                            {canEditXn && <Tooltip>
                                                                <TooltipTrigger asChild>
                                                                    <Button
                                                                        variant="ghost"
                                                                        size="sm"
                                                                        className={`!pl-0 !ml-0 ${actionButton}`}

                                                                        onClick={(e) => handleItemAction("EDIT", xn, "transaction", e)}
                                                                    >
                                                                        <Pencil className="h-3 w-3 text-sahi-blue" />
                                                                    </Button>
                                                                </TooltipTrigger>
                                                                <TooltipContent>
                                                                    <p>Edit Transaction</p>
                                                                </TooltipContent>
                                                            </Tooltip>}
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </CardContent>
                            </Card>

                            {/* Pagination Component */}
                            <PaginationComp
                                currentPage={currentPage}
                                totalPages={totalPages}
                                rowsPerPage={rowsPerPage}
                                onRowsPerPageChange={(size) => setRowsPerPage(size)}
                                onPageChange={(page) => setCurrentPage(page)}
                            />
                        </>
                    )
                )}
            </>
        );
    };

    // Transaction type filter groups
    const filteredFlowGroups = {
        sales: txnTypes.filter((t) => t.Typ === "S"),
        purchases: txnTypes.filter((t) => t.Typ === "P"),
    };

    // Add this function before the Transactions component

    // Transaction Type Filter for Desktop
    const TransactionTypeFilterDesktop = () => {
        const typesStr = selectedFilters.txnTypes?.toString();

        const typeStats = useMemo(() =>
            calculateTransactionTypeStats(txn, selectedFilters, isRecordInDateRange),
            [txn, selectedFilters.connID, selectedFilters.dateRange, selectedFilters.otherMonth, selectedFilters.otherQuarter, selectedFilters.otherYear]
        );

        const toggleTypeFilter = (xnTID) => {
            const xnTIDStr = xnTID.toString();
            setSelectedFilters((prev) => {
                const updated = typesStr.includes(xnTIDStr) ? typesStr.replace(xnTIDStr, "") : typesStr + xnTIDStr;
                return { ...prev, txnTypes: updated, stage: "all" };
            });
            setTempFilters((prev) => {
                const updated = typesStr.includes(xnTIDStr) ? typesStr.replace(xnTIDStr, "") : typesStr + xnTIDStr;
                return { ...prev, txnTypes: updated, stage: "all" };
            });
        };

        const renderTransactionTypeGroup = (groupKey) => {
            const options = filteredFlowGroups[groupKey];
            const availableOptions = options.filter(t => {
                const stats = typeStats[t.XnTID.toString()];
                return stats && stats.count > 0;
            });

            if (availableOptions.length === 0) return null;

            return availableOptions.map((t) => {
                const stats = typeStats[t.XnTID.toString()];
                const isSelected = typesStr === "all" || typesStr.includes(t.XnTID.toString());

                return (
                    <Button
                        key={t.XnTID}
                        variant="semidefaultcol"
                        className={cn(
                            "w-auto bg-white text-black sahi-radius px-3 py-2",
                            "filter-border",
                            "flex flex-row items-center align-middle cursor-pointer"
                        )}
                    >
                        <label className="inline-flex items-center gap-1 cursor-pointer">
                            <Checkbox
                                checked={isSelected}
                                onCheckedChange={() => toggleTypeFilter(t.XnTID)}
                                className={checkBoxCss}
                            />
                            <div className="ml-1 flex flex-row items-center gap-1">
                                <ThreadSahiIcon tID={t.XnTID} className="h-4 w-4" Xns={true} />

                                <span className="text-sm font-normal text-black">
                                    {t.LblF === "Sales Invoice" ? "Sales" : t.LblF === "Purchase Invoice" ? "Purchases" : `${t.LblF}s`}
                                </span>

                                <span className="ml-1 flex items-center text-xs text-sub-text-color">
                                    <span className="text-xs font-medium">(</span>
                                    <FormatAmount
                                        amtClassName=" text-sm font-semibold text-text-color"
                                        amount={stats?.totalAmount || 0}
                                        currency={currencySymbol}
                                    />
                                    <span className="text-xs font-medium ml-0.5">)</span>
                                </span>
                            </div>
                        </label>
                    </Button>
                );
            });
        };

        const renderTransactionTypeGroupMobile = (groupKey) => {
            const options = filteredFlowGroups[groupKey];
            const availableOptions = options.filter(t => {
                const stats = typeStats[t.XnTID.toString()];
                return stats && stats.count > 0;
            });

            if (availableOptions.length === 0) return null;

            return availableOptions.map((t) => {
                const stats = typeStats[t.XnTID.toString()];
                const isSelected = typesStr === "all" || typesStr.includes(t.XnTID.toString());

                return (
                    <Button
                        key={t.XnTID}
                        variant="semidefaultcol"
                        className={cn(
                            " bg-white text-black sahi-radius p-1.5 h-auto",
                            "filter-border",
                            "flex flex-wrap items-start gap-2 justify-start cursor-pointer"
                        )}
                    >
                        <label className="flex items-center gap-1 cursor-pointer">
                            <Checkbox
                                checked={isSelected}
                                onCheckedChange={() => toggleTypeFilter(t.XnTID)}
                                className={checkBoxCss}
                            />
                            <div className="ml-1 flex flex-row items-center gap-1">
                                <ThreadSahiIcon tID={t.XnTID} className="h-4 w-4" Xns={true} />

                                <span className="text-[10px] xs:text-xs font-normal text-black">
                                    {t.LblF === "Sales Invoice" ? "Sales" : t.LblF === "Purchase Invoice" ? "Purchases" : `${t.LblF}s`}
                                </span>

                                <span className="ml-1 flex items-center text-xs text-sub-text-color">
                                    <span className="text-xs font-medium">(</span>
                                    <FormatAmount
                                        className=" text-[10px] xs:text-xs font-semibold text-text-color"
                                        amtClassName=" text-[10px] xs:text-xs font-semibold text-text-color"
                                        amount={stats?.totalAmount || 0}
                                        currency={currencySymbol}
                                    />
                                    <span className="text-xs font-medium ml-0.5">)</span>
                                </span>
                            </div>
                        </label>
                    </Button>
                );
            });
        };

        // Check if there are any transaction types with non-zero counts
        const hasNonZeroCounts = ["sales", "purchases"].some(groupKey => {
            const options = filteredFlowGroups[groupKey] || [];
            return options.some(t => {
                const stats = typeStats[t.XnTID.toString()];
                return stats && stats.count > 0;
            });
        });

        // Only render the outer box if there are non-zero counts
        if (!hasNonZeroCounts) return null;

        if (isMobile)
            return (
                <div className="flex flex-wrap gap-1">
                    {renderTransactionTypeGroupMobile("sales")}
                    {renderTransactionTypeGroupMobile("purchases")}
                </div>
            )

        return (
            <div className="flex flex-wrap gap-4">
                {renderTransactionTypeGroup("sales")}
                {renderTransactionTypeGroup("purchases")}
            </div>
        );
    };

    const handleNewTransaction = useCallback((typeId) => {
        flushSync(() => {
            setSelectedTransactionType(typeId);
            setSelectedTransaction(null);
            setTransactionPrefilledData({});
        });

        setDialogStates((prev) => ({ ...prev, transactionEntry: true }));
    }, []);

    // Handle Export to Excel
    const handleExportToExcel = () => {
        const fileName = "TransactionsList";
        
        // Filter out xnTypeID column for export
        const visibleHeaders = getFilteredHeaders().filter(h => h.key !== 'xnTypeID');
        
        exportToExcel(filteredTxns, visibleHeaders, fileName, transactionValueMapper);
        toast.success(`Exporting ${filteredTxns.length} transactions.`);
    };

    // Map transaction values for Excel export
    const transactionValueMapper = (transaction, key) => {
        switch (key) {
            case 'bizName':
                return transaction.bizName || "-";
            case 'contact':
                return transaction.contactName || "-";
            case 'xnNo':
                return transaction.xnNo || "-";
            case 'amtSubTotal':
                return transaction.amtSubTotal || 0;
            case 'amtGrandTotal':
                return transaction.amtGrandTotal || 0;
            case 'xnDT':
                return transaction.xnDT ? format(new Date(transaction.xnDT), "dd-MMM-yyyy") : "-";
            case 'intNotes':
                return transaction.intNotes || "-";
            default:
                return transaction[key] || "-";
        }
    };

    const FilterButton = () => {
        let activeFilterClass = isFilterSelected && !isMobile ? "filter-active" : "";
        let filterIconToggleClass = "h-4 w-4 " + (isMobile ? "" : (isFilterSelected ? "text-sahi-primary-color" : "text-white group-hover:text-sahi-primary-color"));
        return (
            <Button
                className={cn(filterBtn, activeFilterClass)}
                onClick={() => setIsFilterSelected(true)}
                aria-label="Toggle Filter"
            >
                <div className="h-6 w-6 flex items-center justify-center transition-all">
                    <Filter className={cn(filterIconToggleClass)} />
                </div>
            </Button>
        )
    };

    return (
        <TooltipProvider>
            <div className="space-y-3 lg:space-y-6 overflow-x-hidden">
                {/*--------------- Header ------------*/}
                {/* Web Layout */}
                <div className="hidden lg:flex justify-between items-center gap-3">
                    <div className="flex items-center flex-grow">
                        <h1 className="text-3xl font-bold text-text-color mr-4 web-header-name">
                            Transactions
                        </h1>
                        {/* Search Box */}
                        {shouldShowFullUI(txn) && (
                            <div className="flex items-center justify-end flex-grow">
                                <div className="relative w-120 filter-border">
                                    <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-dropdown-white" />
                                    <Input
                                        placeholder="Search"
                                        value={searchTerm}
                                        onChange={(e) => { setSearchTerm(e.target.value) }}
                                        className="pl-10 h-10 border-none focus:outline-none focus:ring-0 shadow-none"
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="flex items-center gap-3">
                        {/* Import Transaction Button */}
                        {!isMobile && (canCreateXn == true) && canShowImportInquiries() && (
                            <Button
                                variant="outline"
                                className="button-config text-base sahi-primary-button py-[6px] px-[10px]"
                                onClick={() => setXnsImpModal(true)}
                            >
                                <div className="flex items-center cursor-pointer">
                                    <Download className="h-4 w-4 mr-2" />
                                    Import
                                </div>
                            </Button>
                        )}

                        {/* Add Transaction Button */}
                        {!isMobile && (
                            <TransactionDropdown
                                onTransactionTypeSelect={handleNewTransaction}

                                // connectionType={connection?.ConnType}

                                externalOpen={transactionDropdownOpen}
                                onExternalOpenChange={setTransactionDropdownOpen}
                                className="text-base"
                            />
                        )}

                        {!isMobile && shouldShowFullUI(txn) && (
                            <Button
                                onClick={handleExportToExcel}
                                className="button-config sahi-primary-button flex items-center py-[6px] px-[10px]"
                            >
                                <FaFileExcel className="h-4 w-4 mx-1" />
                            </Button>
                        )}

                        {shouldShowFullUI(txn) && (
                            <Button
                                className={cn(
                                    "button-config sahi-primary-button flex items-center justify-center group px-2.5 py-[5px] ",
                                    isFilterSelected && "filter-active"
                                )}
                                onClick={() => setIsFilterSelected(prev => !prev)}
                                aria-label="Toggle filter"
                            >
                                <div className="h-6 w-6 flex items-center justify-center transition-all">
                                    <Filter
                                        className={cn(
                                            "h-4 w-4",
                                            isFilterSelected
                                                ? "text-sahi-primary-color"
                                                : "text-white group-hover:text-sahi-primary-color"
                                        )}
                                    />
                                </div>
                            </Button>
                        )}
                    </div>
                </div>

                {/* Mobile view */}
                <div className="f-col lg:hidden gap-3">
                    {/* Search */}
                    {shouldShowFullUI(txn) && (
                        <div className="w-full flex items-center gap-2 pt-2">
                            <div className="relative flex-grow">
                                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-dropdown-white" />
                                <Input
                                    placeholder="Search"
                                    value={searchTerm}
                                    onChange={(e) => {
                                        setSearchTerm(e.target.value);
                                    }}
                                    className="pl-10 h-10 w-full"
                                />
                            </div>
                            <FilterButton />
                        </div>
                    )}
                </div>

                {/*--------------- Filter ------------*/}
                {shouldShowFullUI(txn) && isFilterSelected &&
                    (isMobile ? (
                        <Drawer open={isDrawerOpen} onOpenChange={() => {
                            setIsDrawerOpen(false);
                            setIsFilterSelected(false);
                        }}>
                            <DrawerContent className="p-0 [&>div:first-child]:hidden">
                                <div className="f-col h-[100dvh]">
                                    {/* Header */}
                                    <div className="flex items-center justify-between p-4 border-b-2 border-gray-200 text-xl">
										<div className="flex gap-4 items-center ">
											<DrawerClose tabIndex={-1} className="p-0 w-auto h-auto flex-shrink-0 flex justify-center">
												<ArrowLeft className="h-[24px] w-[24px]" onClick={handleCancel} />
												<span className="sr-only">Back</span>
											</DrawerClose>
											<p className="text-lg font-semibold text-sahi-primary-color">Transaction Filters</p>
										</div>
                                        <button
                                            className="group flex items-center gap-1 text-sm font-light hover:underline transition duration-200 text-sahi-primary-color"
                                            onClick={() => {
                                                handleResetFilters();
                                                setIsFilterSelected(false);
                                            }}
                                        >
                                            <RiResetLeftFill className="group-hover:rotate-[-20deg] transition-transform duration-200" />
                                            <span>Reset</span>
                                        </button>
                                    </div>
                                    {/* Main Content */}
                                    <div className="flex flex-1 overflow-y-auto">
                                        {/* Scrollable Filters */}
                                        <div className="flex-1 p-3 overflow-y-auto filter-scroll-container">
                                            {[
                                                ...filterOptions.slice(0, 5), // Only take first 5 options (excludes txnTypes at index 5)
                                                {
                                                    key: "txnTypes",
                                                    label: "Types",
                                                    options: getTransactionTypeOptions().map((t) => ({ name: t.name, ID: t.ID })),
                                                    searchEnabled: false,
                                                    type: "options",
                                                    showClearButton: true,
                                                    MobileLabel: "Types",
                                                    showAllOption: true,
                                                    mobileDropdownText: "Select Type",
                                                    isSorting: false,
                                                },
                                                {
                                                    key: "sort",
                                                    label: "Sort by",
                                                    options: Object.keys(sortkeyMapMobileFilter),
                                                    type: "sort",
                                                    className: "",
                                                }
                                            ].map(({ key, label, options, displayValue, type, mobileDropdownText, mobileNoLabel, tLabel, mobiledisabled, MobileLabel, showAllOption, isSorting, visibleWhen }) => {
                                                // Handle selectDate type for mobile
                                                if (type === "selectDate") {
                                                    if (!visibleWhen) return null;
                                                    return (
                                                        <div key={key} id={key} className="mb-4">
                                                            <div className="flex flex-wrap gap-2">
                                                                <label className="flex items-center cursor-pointer select-none gap-2 mb-2">
                                                                    <Checkbox
                                                                        checked={tempFilters.selectDate}
                                                                        onCheckedChange={(checked) => {
                                                                            setTempFilters((prev) => ({
                                                                                ...prev,
                                                                                selectDate: checked,
                                                                                selectedDate: checked ? prev.selectedDate : null
                                                                            }));
                                                                        }}
                                                                        className={checkBoxCss}
                                                                    />
                                                                    <span className="text-sm font-medium text-text-color">{label}</span>
                                                                    {tempFilters.selectDate && (
                                                                        <DatePicker
                                                                            value={tempFilters.selectedDate ? format(tempFilters.selectedDate instanceof Date ? tempFilters.selectedDate : new Date(tempFilters.selectedDate), "yyyy-MM-dd") : ""}
                                                                            onChange={(date) => {
                                                                                if (date) {
                                                                                    const dateObj = date instanceof Date ? date : new Date(date);
                                                                                    setTempFilters((prev) => ({
                                                                                        ...prev,
                                                                                        selectedDate: dateObj
                                                                                    }));
                                                                                }
                                                                            }}
                                                                            placeholder="Select date"
                                                                            disableFuture={true}
                                                                            className="!p-0 !w-auto"
                                                                            minDate={getDatePickerLimits().minDate}
                                                                            maxDate={getDatePickerLimits().maxDate}
                                                                        />
                                                                    )}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    );
                                                }
                                                return (
                                                    <div key={key} id={key} className="mb-4">
                                                        <DrawerFilter
                                                            key={key}
                                                            id={key}
                                                            label={label}
                                                            options={options}
                                                            value={tempFilters[key]}
                                                            displayValue={displayValue}
                                                            onChange={(value) => {
                                                                setTempFilters((prev) => ({
                                                                    ...prev,
                                                                    [key]: value,
                                                                    selectDate: false,
                                                                    selectedDate: null,
                                                                }));
                                                            }}
                                                            disabled={mobiledisabled}
                                                            sortConfig={sortConfig}
                                                            setTempsortConfig={setTempsortConfig}
                                                            tempsortConfig={tempsortConfig}
                                                            sortOptionMap={sortkeyMapMobileFilter}
                                                            type={type}
                                                            mobileDropdownText={mobileDropdownText}
                                                            mobileNoLabel={mobileNoLabel}
                                                            tLabel={tLabel}
                                                            MobileLabel={MobileLabel}
                                                            showAllOption={showAllOption}
                                                            isSorting={isSorting}
                                                        />
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                    {/* Footer */}
                                    <DrawerFooter className="sticky bottom-0 border-t-2 p-3 bg-sahi-white">
                                        <DrawerClose>
                                            <div className="f-row justify-start gap-2">
                                                <Button
                                                    className="sahi-primary-button"
                                                    onClick={() => {
                                                        setSelectedFilters(tempFilters);
                                                        setIsDrawerOpen(false);
                                                        setIsFilterSelected(false);
                                                        sortData(
                                                            tempsortConfig.key,
                                                            tempsortConfig.direction
                                                        );
                                                    }}
                                                >
                                                    Apply
                                                </Button>
                                                <Button
                                                    variant="outline"
                                                    className="sahi-secondary-button"
                                                    onClick={handleCancel}
                                                >
                                                    Cancel
                                                </Button>
                                            </div>
                                        </DrawerClose>
                                    </DrawerFooter>
                                </div>
                            </DrawerContent>
                        </Drawer>
                    ) : (
                        <div className="hidden lg:flex flex-wrap gap-4">
                            {filterOptions.slice(0, 4).filter(f => f.type !== "selectDate").map(({ key, label, options, displayValue, searchEnabled, disabled, tLabel, showClearButton, type, visibleWhen }) => {
                                return (
                                    <CommonFilter
                                        key={key}
                                        label={label}
                                        options={options}
                                        value={selectedFilters[key]}
                                        onChange={(value) => {
                                            setSelectedFilters((prev) => ({ ...prev, [key]: value, selectDate: false, selectedDate: null }));
                                            setTempFilters((prev) => ({ ...prev, [key]: value, selectDate: false, selectedDate: null }));
                                        }}
                                        searchEnabled={searchEnabled}
                                        displayValue={displayValue}
                                        disabled={disabled}
                                        tLabel={tLabel}
                                        showClearButton={showClearButton}
                                    />
                                );
                            })}
                            
                            {(selectedFilters.dateRange === "This Month" || (selectedFilters.dateRange === "Other Month" && selectedFilters.otherMonth !== "all")) && (
                                <div className="flex items-center gap-2">
                                    <label className="flex items-center cursor-pointer select-none gap-2 rounded sahi-radius h-10">
                                        <Checkbox
                                            checked={selectedFilters.selectDate}
                                            onCheckedChange={(checked) => {
                                                setSelectedFilters((prev) => ({
                                                    ...prev,
                                                    selectDate: checked,
                                                    selectedDate: checked ? prev.selectedDate : null
                                                }));
                                                setTempFilters((prev) => ({
                                                    ...prev,
                                                    selectDate: checked,
                                                    selectedDate: checked ? prev.selectedDate : null
                                                }));
                                            }}
                                            className={checkBoxCss}
                                        />
                                        <span className="text-base font-medium text-text-color whitespace-nowrap">Select Date</span>
                                    </label>
                                    
                                    {selectedFilters.selectDate && (
                                        <div className="w-40">
                                            <DatePicker
                                                value={selectedFilters.selectedDate ? format(selectedFilters.selectedDate instanceof Date ? selectedFilters.selectedDate : new Date(selectedFilters.selectedDate), "yyyy-MM-dd") : ""}
                                                onChange={(date) => {
                                                    if (date) {
                                                        const dateObj = date instanceof Date ? date : new Date(date);
                                                        setSelectedFilters((prev) => {
                                                            const newState = { ...prev, selectedDate: dateObj };
                                                            return newState;
                                                        });
                                                        setTempFilters((prev) => ({ ...prev, selectedDate: dateObj }));
                                                    }
                                                }}
                                                placeholder="Select date"
                                                disableFuture={true}
                                                className="!space-y-0 !h-10"
                                                minDate={getDatePickerLimits().minDate}
                                                maxDate={getDatePickerLimits().maxDate}
                                                defaultMonth={selectedFilters.dateRange === "Other Month" && selectedFilters.otherMonth !== "all" 
                                                    ? (() => {
                                                        const monthOptions = getMonthsFromMonthlyXns();
                                                        const selectedMonthStr = monthOptions.find(m => m.ID === selectedFilters.otherMonth)?.name;
                                                        if (selectedMonthStr) {
                                                            const [monthStr, yearStr] = selectedMonthStr.split(" ");
                                                            const monthIndex = new Date(`${monthStr} 1, 2000`).getMonth();
                                                            const year = parseInt(yearStr);
                                                            return new Date(year, monthIndex, 1);
                                                        }
                                                        return new Date();
                                                    })()
                                                    : new Date()
                                                }
                                                disableMonthNavigation={selectedFilters.dateRange === "Other Month" && selectedFilters.otherMonth !== "all"}
                                            />
                                        </div>
                                    )}
                                </div>
                            )}
                            
                            <TransactionTypeFilterDesktop />

                        </div>
                    ))}

                {/*--------------- Data Section ------------*/}
                {isMobile ? (
                    <div className="block lg:hidden">
                        <div ref={parentRef} className="overflow-auto scrollbar-hide threads-virtualized-scrollbar">
                            {currentXns.length > 0 ? (
                                <div
                                    className="scrollbar-hide overflow-y-hidden"
                                    style={{
                                        height: `${rowVirtualizer.getTotalSize()}px`,
                                        position: "relative",
                                    }}
                                >
                                    {rowVirtualizer.getVirtualItems().map((virtualRow) => {
                                        const txn = currentXns[virtualRow.index];
                                        return (
                                            <div
                                                key={txn.xnID}
                                                ref={virtualRow.measureElement}
                                                className="absolute top-0 left-0 w-full"
                                                style={{
                                                    transform: `translateY(${virtualRow.start}px)`,
                                                }}
                                            >
                                                <MobileCard txn={txn} />
                                            </div>
                                        );
                                    })}
                                </div>
                            ) : (
                                <>
                                    <p className="no-records mb-3 lg:whitespace-nowrap">
                                        No transactions found.
                                    </p>
                                </>
                            )}
                        </div>
                        {/* Add Button as Card */}
                        <div className="flex flex-col sm:flex-row gap-2 pt-2">
                            <TransactionDropdown
                                onTransactionTypeSelect={handleNewTransaction}
                                externalOpen={transactionDropdownOpen}
                                onExternalOpenChange={setTransactionDropdownOpen}
                                className="text-sm"
                            />
                        </div>
                    </div>
                ) : (
                    shouldShowFullUI(txn) ? <WebDataTable /> : (
                        <div className="hidden lg:block">
                            <div className="f-col items-start gap-5 mt-0">
                                <div className="no-records border border-gray-200 shadow-sm sahi-radius">
                                    No transactions found.
                                </div>

                                <div className="flex items-center gap-3">
                                    {canCreateXn == true && canShowImportInquiries() &&
                                        <Button
                                            variant="outline"
                                            className="button-config text-base sahi-primary-button py-[6px] px-[10px]"
                                            onClick={() => setXnsImpModal(true)}
                                        >
                                            <div className="flex items-center cursor-pointer">
                                                <Download className="h-4 w-4 mr-2" />
                                                Import
                                            </div>
                                        </Button>
                                    }

                                    <TransactionDropdown
                                        onTransactionTypeSelect={handleNewTransaction}
                                        externalOpen={transactionDropdownOpen2}
                                        onExternalOpenChange={setTransactionDropdownOpen2}
                                        className="text-base"
                                    />
                                </div>
                            </div>
                        </div>
                    )
                )}
            </div>
            <TransactionEntry
                isOpen={dialogStates.transactionEntry}
                onClose={() => {
                    setDialogStates((prev) => ({ ...prev, transactionEntry: false }));
                    setSelectedTransaction(null);
                    setTransactionPrefilledData({});
                }}
                transactionTypeID={selectedTransactionType}
                connID={selectedTransaction ? transactionPrefilledData.connection : null} // Null for new entries
                prefilledData={selectedTransaction ? transactionPrefilledData : {}} // Empty for new entries
                companyName={
                    selectedTransaction
                        ? connData.find((c) => c.connID === transactionPrefilledData?.connection)?.bizName || ""
                        : "" // Empty for new entries
                }
                transactionID={selectedTransaction?.xnID || null} // Null for new entries
                onTransactionSaved={() => {
                    fetchTransactionData();
                }}
                newEntry={true}
            />
            {openXnsImpModal && (
                <ImportXnsExcel
                    open={openXnsImpModal}
                    onClose={() => setXnsImpModal(false)}
                />
            )}
        </TooltipProvider>
    );
};

export default Transactions;